<nz-spin nzTip="Loading" [nzSpinning]="isSpinning">
    <div class="invoice-component">
        <div class="flex-1">
          <form [formGroup]="searchFormData">
            <div nz-row [nzGutter]="20">
              <div nz-col [nzSpan]="7" >
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"SEARCH" | translate}}</nz-form-label>
                  <nz-form-control class="line">
                    <div nz-row [nzGutter]="20">
                      <div nz-col [nzSpan]="10">
                        <nz-select formControlName="keywordsType" (ngModelChange)="changeKeywords()"  [nzSuffixIcon]="suffixSearch">
                            <nz-option *ngFor="let item of codeTypeList; let i = index" [nzValue]="item.value"
                            [nzLabel]="item.name"></nz-option>
                        </nz-select>
                        <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
                      </div>
                      <div nz-col [nzSpan]="14" class="flex-v-center">
                        <div class="search-line"></div>
                        <nz-input-group [nzSuffix]="suffixTemplateInfo"  >
                        <input (keydown.enter)="onInputEnter($event)" nz-input type="text"  formControlName="keywords" [placeholder]="'PLEASE_INPUT' | translate" />
                        <ng-template #suffixTemplateInfo>
                          <i class="search" (click)="handleChange($event)"></i>
                        </ng-template>
                      </nz-input-group>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="3">
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"INVOICE_TYPE" | translate}}</nz-form-label>
                  <nz-form-control  class="line">
                    <nz-select formControlName="invoiceType" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
                        <nz-option *ngFor="let item of typeList; let i = index" [nzValue]="item.value"
                        [nzLabel]="item.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="3">
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"INVOICE_STATUS" | translate}}</nz-form-label>
                  <nz-form-control  class="line">
                    <nz-select formControlName="invoiceStatus" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
                        <nz-option *ngFor="let item of statusList; let i = index" [nzValue]="item.value"
                        [nzLabel]="item.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="3">
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"SORT_BY" | translate}}</nz-form-label>
                  <nz-form-control class="line">
                    <nz-select formControlName="sortType" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
                      <nz-option *ngFor="let item of sortList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="4">
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"ISSUE_DATE" | translate}}</nz-form-label>
                  <nz-form-control class="line">
                    <nz-range-picker class="w100" formControlName="issueDate"  (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixDate"></nz-range-picker>
                  </nz-form-control>
                  <ng-template #suffixDate><i class="search-date"></i></ng-template>
                </nz-form-item>
              </div>
              <div nz-col [nzSpan]="4">
                <nz-form-item class="search-form-item">
                  <nz-form-label>{{"DUE_DATE" | translate}}</nz-form-label>
                  <nz-form-control class="line">
                    <nz-range-picker class="w100" formControlName="paymentDueDate"  (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixDate"></nz-range-picker>
                  </nz-form-control>
                  <ng-template #suffixDate><i class="search-date"></i></ng-template>
                </nz-form-item>
              </div>
            </div>
          </form>
          <div class="result-table">
            <nz-table
            nzShowSizeChanger
            nzShowPagination
            [nzFrontPagination]="false"
            [nzShowTotal]="totalTemplate"
            [nzData]="financialListData"
            [nzTotal]="pagination.total"
            [nzPageIndex]="pagination.pageIndex"
            [nzPageSize]="pagination.pageSize"
            [nzPageSizeOptions]="pagination.pageSizeOptions"
            (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)"
            >
            <thead>
              <tr>
                <th>{{"INVOICE" | translate}}</th>
                <th>{{"PO_No" | translate}}</th>
                <th> {{"ORDER_NO" | translate}}</th>
                <th>{{"INVOICE_DATE" | translate}}</th>
                <th>{{"DUE_DATE" | translate}}</th>
                <th>{{"INVOICE_TOTAL" | translate}}</th>
                <th>{{"PAYER" | translate}}</th>
                <th>{{"PAYMENT_TERMS" | translate}}</th>
                <th>{{"STATUS" | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of financialListData">
                <td>
                 {{ data.invoiceNo }}
                </td>
                <td> {{data.poNo}}</td>
                <td> <div class="link" (click)="goPage('order/detail',data.orderNo)">{{ data.orderNo }}</div></td>
                <td>{{ data.invoiceDate }}</td>
                <td>{{ data.paymentDueDate }}</td>
                <td>{{ data.currency }} {{ data.totalAmount }}</td>
                <td>{{data.customerId}} {{ data.customerName }}</td>
                <td>{{ data.paymentCondition }}</td>
                <td><custom-tag [content]="data.invoiceStatus" [backgroundColor]="getColorByStatus(data.invoiceStatus,true,false)" [fontColor]="getColorByStatus(data.invoiceStatus,false,false)" [borderColor]="getColorByStatus(data.invoiceStatus,false,true)"></custom-tag></td>
              </tr>
            </tbody>
          </nz-table>
          <ng-template #totalTemplate let-total>{{
            "TOTAL_ITEM" | translate : { total }
          }}</ng-template>
          </div>

        </div>
    </div>  
  </nz-spin>
  
  